import {
  ChevronUp,
  Edit,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { secureExportToExcel } from "../../utils/secureExcelUtils";
import ListDetailsView from "./listdetailsview";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { getLists } from "../../core/api/mediaplan";

const Lists = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [lists, setLists] = useState([]);
  const [filteredLists, setFilteredLists] = useState([]);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [selectedListId, setSelectedListId] = useState(null);
  const sidebarRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [ loading, setLoading ] = useState( false );
  useEffect(() => {
    fetchLists();
  }, []);

  const fetchLists = async () => {
    setLoading(true);
    try {
      const response = await getLists();
      setLists(response.data);
      setFilteredLists( response.data );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching lists:", error);
      Swal.fire({
        icon: "error",
        title: "Fetch Error",
        text: "Failed to fetch lists. Please try again later.",
      });
    }
  };

  const transformedLists = lists.flatMap((list) => {
    return list.segments.map((segment, index) => ({
      key: `${list.id}-${segment.code}`,
      listId: list.id,
      list_name: index === 0 ? list.name : null,
      filter_list_name: list.name,
      segment_name: segment.name,
      period: segment.period,
      quantity: segment.quantity,
      category: segment.category,
      date_released: segment.date_released,
      action:
        index === 0 ? (
          <div className="action-table-data">
            <div className="edit-delete-action">
              <Link
                className="me-2 p-2"
                onClick={() => {
                  setSelectedListId(list.id);
                  setSidebarVisible(true);
                }}
                title="Edit"
              >
                <Edit className="feather-edit" />
              </Link>
            </div>
          </div>
        ) : null,
    }));
  });

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filteredData = lists.filter((item) =>
      item.name.toLowerCase().includes(query)
    );

    setFilteredLists(filteredData);
  };

  const exportToExcel = () => {
    const exportData = filteredLists.flatMap((list) =>
      list.segments.map((seg) => ({
        "List Code": list.code,
        "List Name": list.name,
        "Segment Code": seg.code,
        "Segment Name": seg.name,
        Period: seg.period,
        Quantity: seg.quantity,
        Category: seg.category,
        "Date Released": seg.date_released || "-",
      }))
    );

    secureExportToExcel(exportData, "lists.xlsx");
  };

  const columns = [
    {
      title: "List Name",
      dataIndex: "list_name",
      align: "center",
      width: 250,
      render: (value, record) => ({
        children: value,
        props: {
          rowSpan: value
            ? transformedLists.filter((row) => row.listId === record.listId)
                .length
            : 0,
        },
      }),
      filters: [
        ...new Set(
          transformedLists.map((item) => item.filter_list_name).filter(Boolean)
        ),
      ].map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.filter_list_name === value,
    },
    {
      title: "Segment Name",
      dataIndex: "segment_name",
      align: "left",
      width: 250,
    },
    {
      title: "Period",
      dataIndex: "period",
      align: "center",
      width: 150,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
      width: 120,
    },
    {
      title: "Category",
      dataIndex: "category",
      align: "center",
      width: 180,
    },
    {
      title: "Date Released",
      dataIndex: "date_released",
      align: "center",
      width: 180,
      render: (value) => (value ? value : "-"),
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      width: 150,
      render: (value, record) => ({
        children: value,
        props: {
          rowSpan: value
            ? transformedLists.filter((row) => row.listId === record.listId)
                .length
            : 0,
        },
      }),
    },
  ];

  return (
    <div>
      <div
        className="content"
        style={{
          width: isSidebarVisible ? `calc(100% - ${sidebarWidth}px)` : "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Lists</h4>
              <h6>Manage your lists efficiently</h6>
            </div>
          </div>

          <ul className="table-top-head">
            <div className="search-set">
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control form-control-sm formsearch"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <Link to="#" className="btn btn-searchset">
                  <i data-feather="search" className="feather-search" />
                </Link>
              </div>
            </div>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Export to Excel</Tooltip>}
              >
                <Link onClick={exportToExcel}>
                  <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />{" "}
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Refresh</Tooltip>}
              >
                <Link onClick={fetchLists}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}
              >
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>

          <div className="page-btn">
            <button
              className="btn btn-added"
              onClick={() => {
                setSelectedListId(null);
                setSidebarVisible(true);
              }}
            >
              <PlusCircle className="me-2 iconsize" />
              Add New List
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={transformedLists} loading={loading}/>
            </div>
          </div>
        </div>
      </div>

      <ListDetailsView
        isVisible={isSidebarVisible}
        onClose={() => {
          fetchLists();
          setSidebarVisible(false);
        }}
        listId={selectedListId}
        ref={sidebarRef}
        onResize={setSidebarWidth}
        clientId={null}
      />
    </div>
  );
};

export default Lists;
